import { RecordRTCPromisesHandler } from "recordrtc";
import { Util } from "./Utils/Util";
import { UtilApp } from "./Utils/UtilApp";

class VideoRecorder {
  recorder?: RecordRTCPromisesHandler;
  stream?: MediaStream;

  async startScreenRecording(useMic: boolean, onStopSharing: () => void): Promise<string | null> {
    try {
      this.stream = await navigator.mediaDevices.getDisplayMedia({ audio: !useMic, video: true });
      console.log('useMic is', useMic);
      
      if(useMic) {
        let audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });
        audioStream.getTracks().forEach(track => this.stream?.addTrack(track));
      }

      this.stream.getVideoTracks()[0].onended = async () => {
        console.log('User stopped sharing screen');
        if ((await this.recorder?.getState() == 'recording')) {
          onStopSharing();
        }
      }
      const mimeType = UtilApp.isChromeBrowser() ? 'video/webm;codecs=vp8' : undefined; //vp9 makes very large files. vp8/9 can be viewed on Safari.
      this.recorder = new RecordRTCPromisesHandler(this.stream, {
        type: 'video', mimeType: mimeType
      });

      await Util.sleep(500); // Wait a sec so that share dialog disappears.
      await this.recorder!.startRecording();

      return null;
    } catch (error: any) {
      if (error?.name === 'NotAllowedError') {
        console.info('[VideoRecorder] 화면/마이크 권한이 허용되지 않았습니다.');
      } else {
        console.error("Failed to start recording", error);
      }
      this.resetAll();
      return (error as Error).message;
    }
  }

  async pause() {
    if (this.recorder) {
      await this.recorder.stopRecording();
    }
  }

  async finish(): Promise<Blob | null> {
    let state = await this.recorder?.getState();
    if (this.recorder && state) {
      if (['recording', 'paused'].includes(state))
        await this.recorder.stopRecording();

      let blob = await this.recorder.getBlob();
      this.resetAll();

      return blob;
    }
    return null;
  }

  async resetAll() {
    if (this.recorder) {
      await this.recorder.reset();
      await this.recorder.destroy();
      this.recorder = undefined;
    }
    if (this.stream) {
      this.stream.getTracks().forEach(t => t.stop());
    }
  }
}

export default VideoRecorder;





